.new-asset-view {
    width: 450px;
    margin-left: 10px;
}

.new-asset-view .file-drop {
    height: 100px;
    width: 100%;
}